import React, { useMemo, useRef, useState } from "react";

import styles from "./VideoPlaye3.module.css";
import "./videoConfig.css";

import ReactPlayer from "react-player";
import Mobile, { fullScreenHandler } from "../Mobile/Mobile";
import TimeLine from "../TimeLine/TimeLine";
import { toast } from "react-toastify";
import {I_TechItemPart} from "../../../../Models/interfaces";

type xProps = {
  videoSrc: string;
  userNumber: string;
  currDataIndex: number;
  teachData?: I_TechItemPart;
  onVideoSelected: () => void;
  setCurrDataIndex: React.Dispatch<React.SetStateAction<number>>;
};

const X = ({ children }: any) => (
  <div className={`${styles.videoContainer} `}>{children}</div>
);

const VideoPlayer3: React.FunctionComponent<xProps> = ({
  videoSrc,
  userNumber,
  currDataIndex,
  teachData,
  onVideoSelected,
  setCurrDataIndex,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOverlayInScreen, setIsOverlayInScreen] = useState<boolean>(false);
  const [videoTime, s] = useState<number>(0);

  const video = useMemo(
    () => (
      <ReactPlayer
        url={videoSrc}
        playing
        playsinline
        wrapper={X}
        config={{
          file: {
            attributes: {
              loop: false,
              autoPlay: true,
              playsInline: true,
              muted: false,
              controls: false,
              controlsList: "nodownload",
            },
          },
        }}
        onBuffer={() => {}}
        onBufferEnd={() => {}}
        onError={() => {
          toast("مشکلی در اتصال شبکه وجود دارد", {
            type: "error",
          });
        }}
        controls={false}
        onEnded={() => {
            if(currDataIndex < Number(teachData?.data.length) - 1){
                setCurrDataIndex((prevState) => {
                    if (prevState === Number(teachData?.data.length) - 1) {
                        return prevState;
                    }
                    return prevState + 1;
                });
                onVideoSelected();
            }
        }}
        onProgress={(e) => {
          s(e.playedSeconds);
        }}
      />
    ),
    [videoSrc]
  );

  return (
    <div
      className={`${styles.videoPlayer3Container}`}
      ref={containerRef}
      onClick={() => {
        setIsOverlayInScreen((prevState) => !prevState);
      }}
      onDoubleClick={() => {
        fullScreenHandler(containerRef, "", (status) => {
          if (status === "exit") {
            containerRef.current?.children[1].classList.remove("full");
          }
          if (status === "enter") {
            containerRef.current?.children[1].classList.add("full");
          }
        });
      }}
    >
      <Mobile mobileNumber={userNumber} />
      {video}

      {isOverlayInScreen && (
        <TimeLine
          currentTime={document.querySelector("video")?.currentTime || 0}
          videoTime={document.querySelector("video")?.duration || 0}
          videoRef={{ current: document.querySelector("video") }}
          containerRef={containerRef}
          x={videoTime}
        />
      )}
    </div>
  );
};

export default VideoPlayer3;
